//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GmapCustomMarker from 'vue2-gmap-custom-marker';

export default {
	data() {
		return {
			marker: [
				{
					lat: -34.905118132054966,
					lng: 138.5447963269795,
				},
				// {
				// 	lat: -34.813369105685744,
				// 	lng: 138.60717189586944,
				// },
			],
		};
	},

	props: {
		marker_icon: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {
		GmapCustomMarker,
	},

	created() {},
	mounted() {},
};



// WEBPACK FOOTER //
// ./scripts/vue/GoogleMap.vue